<div class="chat-window">
  <div class="chat-header">
    <p>Chat</p>
    <button
      class="has-tooltip"
      (click)="closeChat.emit()"
      aria-label="Close chat"
      data-tooltip="Close chat"
      data-tooltip-position="below">
      &times;
    </button>
  </div>
  <div class="chat-body" #chatBody>
    <!-- Existing chat messages and UI -->
    <div *ngFor="let msg of messages" class="message" [ngClass]="{ 'user-message': msg.user === 'Me' }">
      <strong>{{ msg.user }}:</strong> <span [innerHTML]="msg.message"></span>
    </div>

    <!-- Bot typing indicator -->
    @if (isResponding) {
    <div class="message bot-message">
      <strong>Bueno:</strong>
      <span class="message-bubble">
        @if (currentMessage) {
        <span class="typing-message">{{ currentMessage }}</span>
        } @else {
        <span class="typing-placeholder">Bueno AI will answer shortly</span>
        <span class="typing-indicator">
          <span class="typing-dot"></span>
          <span class="typing-dot"></span>
          <span class="typing-dot"></span>
        </span>
        }
      </span>
    </div>
    }
  </div>
  <div class="chat-footer">
    <button
      class="clear-button has-tooltip"
      type="button"
      (click)="clearChat()"
      aria-label="Clear chat history"
      data-tooltip="Clear chat">
      <fa-icon [icon]="faTrash"></fa-icon>
    </button>
    <input [(ngModel)]="newMessage" (keyup.enter)="sendMessage()" placeholder="Type a message..." />
    <button
      class="send-button has-tooltip"
      type="button"
      (click)="sendMessage()"
      aria-label="Send message"
      data-tooltip="Send message">
      <fa-icon [icon]="faPaperPlane"></fa-icon>
    </button>
  </div>
</div>
